// Pricing configuration for Lovable Cloud-managed checkouts.
// Payment processing is handled by Lemon Squeezy (see src/components/checkout/).
//
// SOURCE OF TRUTH: this file is the single source of truth for every price,
// message limit, and plan name shown anywhere in the site. The /pricing page
// reads from here, and so must every other page (home, documents, tools, AI
// Assistant, Risk Management, FAQ, etc.). Do NOT hard-code prices or message
// limits anywhere else. If a value needs to change, change it here only.

export const PRICING_CONFIG = {
  // Pro Prices in USD
  prices: {
    monthly: 149,
    yearly: 999,
    yearlyFounding: 999,
  },

  // ISO 27001 Document Pack one-time purchase
  wordPack: {
    price: 99,
    currency: 'USD',
    downloadUrl: {
      en: '/downloads/iso27001kit-customizable-word-pack.zip',
      fr: '/downloads/iso27001kit-customizable-word-pack-fr.zip',
    },
  },

  // Implementation Bundle (one-time, contact-only in v1)
  implementationBundle: {
    price: 2997,
    currency: 'USD',
  },

  // SECURITY: This must be false in production!
  // Set to true only for local development to simulate being a paid Pro user.
  simulatePaidUser: false,
};

// Unified plan model. New code should read from PRICING; legacy code can
// keep using PRICING_CONFIG above (same numbers, just kept for compatibility).
export const PRICING = {
  free: {
    name: 'Free',
    price: 0,
    priceLabel: '$0',
    messagesPerDay: 3,
  },
  docPack: {
    name: 'ISO 27001 Document Pack',
    price: PRICING_CONFIG.wordPack.price, // 99
    priceLabel: `$${PRICING_CONFIG.wordPack.price}`,
    period: 'one-time',
    currency: PRICING_CONFIG.wordPack.currency,
  },
  aiPlus: {
    name: 'AI Assistant Plus',
    price: 9,
    priceLabel: '$9',
    period: '/mo',
    messagesPerDay: 30,
  },
  pro: {
    name: 'ISO 27001 Audit Room',
    monthly: PRICING_CONFIG.prices.monthly,        // 149
    yearly: PRICING_CONFIG.prices.yearly,          // 999
    foundingYearly: PRICING_CONFIG.prices.yearlyFounding, // 999
    monthlyLabel: `$${PRICING_CONFIG.prices.monthly}`,
    yearlyLabel: `$${PRICING_CONFIG.prices.yearly}`,
    messagesPerDay: 150,
    get yearlySavings() {
      return PRICING_CONFIG.prices.monthly * 12 - PRICING_CONFIG.prices.yearly;
    },
  },
  bundle: {
    name: 'Implementation Bundle',
    price: PRICING_CONFIG.implementationBundle.price, // 2997
    priceLabel: `$${PRICING_CONFIG.implementationBundle.price}`,
    period: 'one-time',
  },
} as const;

export type PricingPlan = keyof typeof PRICING;
